import { useIsFetching } from 'react-query';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { ActivityCodesFilter } from 'components/common/GlobalFilterComponent/components/ActivityCodesFilter/ActivityCodesFilter';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { TagsFilter } from 'components/common/GlobalFilterComponent/components/TagsFilter/TagsFilter';
import { WbsFilter } from 'components/common/GlobalFilterComponent/components/WbsFilter/wbsFilter';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';

import { useScrollTo } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/ProgramProgressOverview/useScrollTo';
import { ChangeAnalysisWidgetWrapper } from 'components/Dashboards/Project/Components/VersionCompare/changeAnalysisWidgetWrapper';
import { VersionCompareNoData } from 'components/Dashboards/Project/Components/VersionCompare/components/versionCompareNoData/versionCompareNoData';
import { VersionCompareQueryKeys } from 'components/Dashboards/Project/Components/VersionCompare/queries/tableDataQuery';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { TreeProgramTopHeader, VersionCompareSelectorWrapper } from 'components/common';
import VersionCompareTrackedActivities from 'components/widgets/ChangeAnalysisTrackedActivities/versionCompareTrackedActivities';
import WidgetCardsComponent from 'components/widgets/ChangeSummary/widgetCardsComponent';
import CriticalPathAdded from 'components/widgets/CriticalPathAdded/criticalPathAdded';
import CriticalPathRemoved from 'components/widgets/CriticalPathRemoved/criticalPathRemoved';
import LargestAddedActivities from 'components/widgets/LargestAddedActivities/largestAddedActivities';
import LargestDeletedActivities from 'components/widgets/LargestDeletedActivities/largestDeletedActivities';
import LargestDurationVariance from 'components/widgets/LargestDurationVariance/largestDurationVariance';
import LargestFloatChanges from 'components/widgets/LargestFloatChanges/largestFloatChanges';
import RelationshipCountChanges from 'components/widgets/RelationshipCountChanges/relationshipCountChanges';
import FinishDateChanges from 'components/widgets/TopFinishDateChanges/finishDateChanges';
import RelationshipTypeChanges from 'components/widgets/TopRelationshipTypeChanges/relationshipTypeChanges';
import StartDateChanges from 'components/widgets/TopStartDateChanges/startDateChanges';
import StatusChanges from 'components/widgets/TopStatusChanges/statusChanges';

export const ChangeAnalysisPage = () => {
    useFullStoryPageView({ pageName: projectConfig.versionCompare.title });
    const isFetching = useIsFetching({
        predicate: (query) => {
            const key = Array.isArray(query.queryKey) ? query.queryKey[0] : query.queryKey;
            return VersionCompareQueryKeys.includes(key);
        },
    });
    useScrollTo(isFetching);
    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader pageTitle={projectConfig.versionCompare.title} />
                        <VersionCompareSelectorWrapper allowSingleVersion={false} />
                    </VersionSection>
                    <GlobalFilterButton />
                </VersionWrapper>

                <GlobalFilterComponent
                    defaultValues={{ milestoneFragnet: null, tags: [], activityCodes: [], wbs: null }}
                >
                    <MilestoneFragnetFilter name={'milestoneFragnet'} />
                    <TagsFilter name={'tags'} />
                    <ActivityCodesFilter name={'activityCodes'} />
                    <WbsFilter name={'wbs'} />
                </GlobalFilterComponent>
            </HeaderWrapper>

            <MainContent>
                <VersionCompareNoData />
                <PageWidgetWrapper>
                    <ChangeAnalysisWidgetWrapper>
                        <WidgetCardsComponent />
                        <VersionCompareTrackedActivities />
                        <FinishDateChanges />
                        <StartDateChanges />
                        <StatusChanges />
                        <LargestAddedActivities />
                        <LargestDeletedActivities />
                        <CriticalPathAdded />
                        <CriticalPathRemoved />
                        <LargestFloatChanges />
                        <LargestDurationVariance />
                        <RelationshipTypeChanges />
                        <RelationshipCountChanges />
                    </ChangeAnalysisWidgetWrapper>
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={VersionCompareQueryKeys} />
        </PageContainer>
    );
};
